import {noop} from '@benchling/js-utils';
import {Model} from 'backbone';
import React from 'react';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import SectionTabs from 'ui-library/SectionTabs';

export function renderPanelTabs(
  panelState: Model,
  tabs: Array<[key: string, title: string]>,
  node: Element
): void {
  renderToDOM(
    <SectionTabs
      tabs={tabs.map(([key, title]) => ({
        handleClick() {
          panelState.set('activeSubPanel', key);
        },
        isActive: panelState.get('activeSubPanel') === key,
        text: title,
      }))}
    />,
    node
  );
}

export function renderSinglePanelTab(title: string, node: Element): void {
  renderToDOM(<SectionTabs tabs={[{handleClick: noop, isActive: true, text: title}]} />, node);
}
